import {useEffect, useRef, useState} from 'react';

const SHADOW_TOGGLE_THRESHOLD = 3;

export interface UseTopBottomScrollShadowObject {
  topShadow: boolean;
  bottomShadow: boolean;
}

export const useTopBottomScrollShadowNonRef = (scrollingContainer: HTMLElement | null, hasElementMounted?: boolean): UseTopBottomScrollShadowObject => {
  const [isPanelInitialized, setIsPanelInitialized] = useState(false);
  const [topShadow, setTopShadow] = useState(false);
  const [bottomShadow, setBottomShadow] = useState(false);
  const topShadowRef = useRef<boolean>(false);
  const bottomShadowRef = useRef<boolean>(false);

  const handleVerticalScroll = (): void => {
    if (!scrollingContainer) {
      return;
    }
    const scrollTop = scrollingContainer.scrollTop ? scrollingContainer.scrollTop : 0;
    const clientHeight = scrollingContainer?.clientHeight ? scrollingContainer.clientHeight : 0;
    const scrollHeight = scrollingContainer?.scrollHeight ? scrollingContainer.scrollHeight : 0;

    let newTopShadow = topShadowRef.current;
    let newBottomShadow = bottomShadowRef.current;
    if (scrollHeight > clientHeight) {
      if (scrollTop > SHADOW_TOGGLE_THRESHOLD) {
        newTopShadow = true;
      }
      if (scrollTop <= SHADOW_TOGGLE_THRESHOLD) {
        newTopShadow = false;
      }

      if (scrollTop + clientHeight + SHADOW_TOGGLE_THRESHOLD >= scrollHeight) {
        newBottomShadow = false;
      }
      if (scrollTop + clientHeight + SHADOW_TOGGLE_THRESHOLD < scrollHeight) {
        newBottomShadow = true;
      }
    } else {
      newBottomShadow = false;
      newTopShadow = false;
    }

    if (newTopShadow !== topShadowRef.current) {
      topShadowRef.current = newTopShadow;
      setTopShadow(newTopShadow);
    }

    if (newBottomShadow !== bottomShadowRef.current) {
      bottomShadowRef.current = newBottomShadow;
      setBottomShadow(newBottomShadow);
    }
  };

  const handleScroll = (): void => {
    if (scrollingContainer) {
      handleVerticalScroll();
    }
  };

  useEffect(() => {
    handleScroll();
    if (!scrollingContainer) {
      return;
    }
    scrollingContainer.addEventListener(
      'scroll',
      window.PMW.debounce(() => {
        handleScroll();
      }, 100),
      {passive: true}
    );
    if (scrollingContainer && !isPanelInitialized) {
      setIsPanelInitialized(true);
    }
    return () => {
      scrollingContainer.removeEventListener('scroll', handleScroll);
    };
  }, [scrollingContainer, scrollingContainer?.clientHeight, scrollingContainer?.scrollHeight, hasElementMounted]);

  return {
    topShadow,
    bottomShadow,
  };
};
